import type { PopularAccumulatorsConfig } from '@ps/isp-web-services-types';
import React from 'react';

import { useNormalisedBasicData } from '@swf/sports/hooks/useNormalisedBasicData';
import { isMeetingBasedEventTypeId } from '@swf/sports/utils/isEventTypeId';

import EventBasedPopularAccumulatorCard from './components/EventBasedPopularAccumulatorCard/EventBasedPopularAccumulatorCard';
import MeetingBasedPopularAccumulatorCard from './components/MeetingBasedPopularAccumulatorCard/MeetingBasedPopularAccumulatorCard';

interface Props {
  popularAccumulator: PopularAccumulatorsConfig;
}

const PopularAccumulatorCard: React.FC<Props> = ({ popularAccumulator }: Props) => {
  const { market } = useNormalisedBasicData({
    marketId: popularAccumulator.runnerIds[0].marketId
  });

  if (!market) return null;

  return isMeetingBasedEventTypeId(market.eventTypeId) ? (
    <MeetingBasedPopularAccumulatorCard popularAccumulator={popularAccumulator} />
  ) : (
    <EventBasedPopularAccumulatorCard popularAccumulator={popularAccumulator} />
  );
};
export default PopularAccumulatorCard;
